import { FC } from 'react';

import { Row, Typography } from 'antd';

import { Card } from '@hdi-seguros/web-components.card';
import { CardAction, TagProps } from '@hdi-seguros/web-components.card/dist/card';

import { COLORS } from '../../../config/themes/colors';
import { _renderColumns, Column } from '../../../pages/production/InsurancePolicyDetail/utils/renderSections';

import './index.css';

interface PolicyCardProps {
  title:          string;
  article:        string;
  tags?:          Array<TagProps>;
  actions?:       Array<CardAction>;
  loading?:       boolean;
  columnsData:    Array<Column>;
}

const _renderTitle = (title: string, articulo: string) => (
  <div className='policy-card-title-container'>
    <Typography.Text strong style={{ margin: 0, marginRight: 10 }}>
      {' '}
      {title}
    </Typography.Text>
    <Typography.Text
      style={{ margin: 0, marginRight: 20, color: COLORS.neutrals[70] }}
    >
      {' '}
      / {articulo}
    </Typography.Text>
  </div>
);

export const PolicyCard: FC<PolicyCardProps> = ({ title, article, tags, actions = [], loading, columnsData }) => {
  return (
    <div className='container-policy-card'>
      <Card
        title={_renderTitle(title, article?.toUpperCase())}
        tags={tags}
        actions={actions}
        loading={loading}
        className='policy-card'
      >
        <Row gutter={[10, 10]}>
          {_renderColumns(columnsData)}
        </Row>
      </Card>
    </div>
  )
}

